import React from "react";
import { FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { isUrdu } from "../../../constants/const";

// The search model posted to member/getMembersReport. The `ui` part only drives the page (labels for
// chips, which advanced filters are switched on) and is stripped before posting.
export const createDefaultSearchModel = (loggedInUnitId) => ({
  name: "",
  fatherName: "",
  regNo: "",
  phoneNo: "",
  address: "",
  responsibilityIds: [],
  memberTypeIds: [],
  isSubUnits: true,
  includeEXMember: false,
  complete: true,
  inComplete: false,
  includeCourse: true,
  includeEvent: true,
  attendanceStatus: 1,
  isOnTime: true,
  unitId: loggedInUnitId,
  loggedInUnitId: loggedInUnitId,
  courseTypeIds: [],
  eventTypeIds: [],
  courseStartDate: null,
  courseEndDate: null,
  eventStartDate: null,
  eventEndDate: null,
  serachButton: true,
  ui: {
    unitName: "",
    showExUnits: false,
    eventsOn: false,
    coursesOn: false,
    responsibilities: [],
    memberTypes: [],
    eventTypes: [],
    courseTypes: [],
  },
});

export const resetEventFilter = (model) => ({
  ...model,
  includeEvent: true,
  attendanceStatus: 1,
  isOnTime: true,
  eventStartDate: null,
  eventEndDate: null,
  eventTypeIds: [],
  ui: { ...model.ui, eventsOn: false, eventTypes: [] },
});

export const resetCourseFilter = (model) => ({
  ...model,
  courseStartDate: null,
  courseEndDate: null,
  courseTypeIds: [],
  ui: { ...model.ui, coursesOn: false, courseTypes: [] },
});

export const toSearchPayload = (model, sortModel) => {
  const { ui, ...payload } = model;
  return { ...payload, sortModel };
};

const TEXT_FILTERS = [
  { key: "name", label: "member_report_member_name" },
  { key: "fatherName", label: "member_report_member_fatherName" },
  { key: "regNo", label: "member_report_member_registrationNumber" },
  { key: "phoneNo", label: "member_report_phone_email" },
  { key: "address", label: "member_report_address" },
];

const joinLabels = (options) => options.map((o) => o.label).join("، ");

// Describes the applied filters as chips. Unit and sub-units describe the scope and can't be removed
// from the chip; everything else can.
export const buildAppliedFilters = (model) => {
  const chips = [];
  if (model.unitId !== 0 && model.ui.unitName)
    chips.push({ key: "unit", label: "member_report_section_unit", value: model.ui.unitName });
  if (model.isSubUnits) chips.push({ key: "subUnits", text: "member_report_chip_sub_units" });
  TEXT_FILTERS.forEach(({ key, label }) => {
    if (model[key] && model[key].trim() !== "")
      chips.push({ key, label, value: model[key].trim(), removable: true });
  });
  if (model.ui.responsibilities.length > 0)
    chips.push({
      key: "responsibility",
      label: "member_report_responsibility",
      value: joinLabels(model.ui.responsibilities),
      removable: true,
    });
  if (model.ui.memberTypes.length > 0)
    chips.push({
      key: "memberType",
      label: "member_report_member_memberType",
      value: joinLabels(model.ui.memberTypes),
      removable: true,
    });
  if (model.includeEXMember) chips.push({ key: "exMembers", text: "member_report_chip_ex_members", removable: true });
  if (model.ui.eventsOn && model.ui.eventTypes.length > 0)
    chips.push({
      key: "events",
      label: model.includeEvent ? "member_report_chip_events_attended" : "member_report_chip_events_missed",
      value: joinLabels(model.ui.eventTypes),
      removable: true,
    });
  if (model.ui.coursesOn && model.ui.courseTypes.length > 0)
    chips.push({
      key: "courses",
      label: model.includeCourse ? "member_report_chip_courses_attended" : "member_report_chip_courses_missed",
      value: joinLabels(model.ui.courseTypes),
      removable: true,
    });
  return chips;
};

export const removeAppliedFilter = (model, key) => {
  switch (key) {
    case "responsibility":
      return { ...model, responsibilityIds: [], ui: { ...model.ui, responsibilities: [] } };
    case "memberType":
      return { ...model, memberTypeIds: [], ui: { ...model.ui, memberTypes: [] } };
    case "exMembers":
      return { ...model, includeEXMember: false };
    case "events":
      return resetEventFilter(model);
    case "courses":
      return resetCourseFilter(model);
    default:
      return { ...model, [key]: "" };
  }
};

export const FilterChips = ({ chips, onRemove }) => {
  const { t } = useTranslation();
  return chips.map((chip) => (
    <span key={chip.key} className={"mr-fchip" + (chip.removable && onRemove ? "" : " mr-static")}>
      {chip.text ? (
        t(chip.text)
      ) : (
        <>
          <small>{t(chip.label)}</small>
          <span className={isUrdu(chip.value) ? "ur" : ""}>{chip.value}</span>
        </>
      )}
      {chip.removable && onRemove && (
        <button
          type="button"
          className="mr-x"
          title={t("member_report_remove_filter")}
          onClick={() => onRemove(chip.key)}
        >
          <FiX size={12} />
        </button>
      )}
    </span>
  ));
};
